import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { get, post, _delete, put } from "util/requests";
import styles from "../drug_management.module.css";
import { Dialog } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import RadioGroup from "ui/crfs/radio_group";
import Select from "ui/crfs/select";
import DateTime from "ui/crfs/date_time";
import Text from "ui/crfs/text";
import ClearIcon from "@mui/icons-material/Clear";
import moment from "moment";
import { arrayHaveCommonItems } from "util/helpers";

export default function BatchActionDrugModal(props) {
  const { showingModal = false, setShowingModal, subject_id, RefetchTableData, study_id } = props;

  const permissions = useSelector((state) => state.user.userData.permissions);

  const [spinning, setSpinning] = useState(false);
  const [deleteSpinning, setDeleteSpinning] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [files, setFiles] = useState([]);
  const [valueObj, setValueObj] = useState({});
  const dropMenuRef = useRef(null);
  const uploadRef = useRef(null);

  useEffect(() => {
    if (showingModal.constructor === Boolean) {
      setValueObj({});
      setFiles([]);
    } else {
      setValueObj({
        deviation_reason: { value: showingModal.deviation_reason },
        corrective_action: { value: showingModal.corrective_action },
        clinical_trial_name: { value: showingModal.clinical_trial_name },
        comments: { value: showingModal.comments },
        ethics_notified: { value: showingModal.ethics_notified },
        other_deviation_details: { value: showingModal.other_deviation_details },
        consent_id: showingModal.consent_id,
        data_from_open: true,
      });
      if (showingModal.file_name) {
        setFiles([{ name: showingModal.file_name, id: showingModal.file_id }]);
      }
    }
    setDeleteConfirm(false);
    setDeleteSpinning(false);
  }, [showingModal]);

  const handleFileChange = (e) => {
    setFiles([e.target.files[0]]);
  };

  const submit_form = (is_update = false) => {
    let data = { subject_id, is_update, deviation_id: showingModal.id || null, study_id };
    Object.entries(valueObj).forEach(([key, value]) => {
      if (value?.value) data[key] = value.value;
    });

    post("/deviation", data).then(() => {
      setShowingModal(false);
      setSpinning(false);
      RefetchTableData();
    });
  };

  const deactivate_form = () => {
    setDeleteSpinning(true);
    _delete(`/deviation/${subject_id}/${showingModal.id}?study_id=${study_id}`).then(() => {
      setDeleteSpinning(false);
      setShowingModal(false);
      RefetchTableData();
    });
  };

  const activate_form = () => {
    setDeleteSpinning(true);
    put(`/deviation/${subject_id}/${showingModal.id}?study_id=${study_id}`).then(() => {
      setDeleteSpinning(false);
      setShowingModal(false);
      RefetchTableData();
    });
  };

  const openFile = (id, name) => {
    get(`/presigned_url/${id}`).then((ret) => {
      if (ret.data?.url) {
        window.open(ret.data.url, "_blank");
      }
    });
  };

  const title = showingModal.constructor === Boolean ? "Batch Drug Actions" : "Edit Drug";

  const submitDisabled = !(
    valueObj.deviation_reason?.value &&
    ((valueObj.deviation_reason?.value === "enrolled_other_trial" &&
      valueObj.clinical_trial_name?.value &&
      valueObj.comments?.value) ||
      (valueObj.deviation_reason?.value === "other" && valueObj.other_deviation_details?.value)) &&
    valueObj.corrective_action?.value &&
    valueObj.ethics_notified?.value
  );
  const read_only =
    !permissions.includes("consent_record_update") ||
    (valueObj.consent_type?.value === "deferred_waiver_consent" && valueObj.data_from_open);

  return (
    <Dialog open={showingModal} onClose={() => setShowingModal(false)} maxWidth={800}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_title}>{title}</div>
        <input ref={uploadRef} type="file" onChange={handleFileChange} style={{ display: "none" }} />

        {showingModal.constructor === Boolean && showingModal ? (
          <React.Fragment>
            <div className={styles.modal_button_wrapper}>
              <LoadingButton
                disabled={submitDisabled}
                variant="contained"
                loading={spinning}
                onClick={() => {
                  setSpinning(true);
                  submit_form();
                }}
              >
                Submit
              </LoadingButton>
              <LoadingButton disabled={false} variant="outlined" loading={false} onClick={() => setShowingModal(false)}>
                Cancel
              </LoadingButton>
            </div>
          </React.Fragment>
        ) : null}
        {showingModal.constructor !== Boolean && !deleteConfirm && permissions.includes("consent_record_update") ? (
          <React.Fragment>
            <div className={styles.modal_button_wrapper}>
              <LoadingButton
                disabled={false}
                variant="contained"
                loading={spinning}
                onClick={() => {
                  setSpinning(true);
                  submit_form(true);
                }}
              >
                Update
              </LoadingButton>

              <LoadingButton
                disabled={false}
                variant="contained"
                loading={false}
                onClick={showingModal.status === "inactive" ? activate_form : deactivate_form}
                color="inherit"
                sx={{ color: "#555" }}
              >
                {showingModal.status === "inactive" ? "Activate" : "Deactivate"}
              </LoadingButton>
              <LoadingButton disabled={false} variant="outlined" loading={false} onClick={() => setShowingModal(false)}>
                Close
              </LoadingButton>
            </div>
          </React.Fragment>
        ) : null}

        {showingModal.constructor !== Boolean && !permissions.includes("consent_record_update") ? (
          <div className={styles.modal_button_wrapper}>
            <LoadingButton disabled={false} variant="outlined" loading={false} onClick={() => setShowingModal(false)}>
              Close
            </LoadingButton>
          </div>
        ) : null}
      </div>
    </Dialog>
  );
}
